import { PageLoader } from "#/components/ui/page-loader";
import { useWallet } from "#/hooks/use-wallet";
import { AccountOverview } from "./account-overview";
import { BalancesTable } from "./balances-table";
import { FeeOverview } from "./fee-overview";
import { OpenOrdersTable } from "./open-orders-table";
import { PortfolioChart } from "./portfolio-chart";
import { PortfolioLoginGate } from "./portfolio-login-gate";
import { PositionsTable } from "./positions-table";
import { RecentTradesTable } from "./recent-trades-table";
import { TransactionHistoryTable } from "./transaction-history-table";
import { WalletOverview } from "./wallet-overview";

export function PortfolioLayout() {
	const wallet = useWallet();

	if (!wallet.isReady || (wallet.isAuthenticated && !wallet.isConnected)) {
		return <PageLoader />;
	}

	if (!wallet.isConnected) {
		return (
			<div className="relative max-h-[85vh] overflow-hidden">
				<div inert className="select-none opacity-40">
					<PortfolioSections />
				</div>
				<div className="pointer-events-none absolute inset-x-0 bottom-0 h-32 bg-gradient-to-b from-transparent to-background" />
				<div className="absolute inset-0 flex items-center justify-center p-4">
					<PortfolioLoginGate
						onLogin={() => wallet.connect("portfolio")}
						loginDisabled={!wallet.isReady}
					/>
				</div>
			</div>
		);
	}

	return <PortfolioSections />;
}

function PortfolioSections() {
	return (
		<div className="mx-auto flex max-w-7xl flex-col divide-y divide-border p-4 pt-10 [&>*]:py-6 [&>*:first-child]:pt-0 [&>*:last-child]:pb-0">
			<div className="grid gap-8 xl:grid-cols-2 xl:gap-0 xl:divide-x xl:divide-border">
				<div className="xl:pr-8">
					<WalletOverview />
				</div>
				<div className="xl:pl-8">
					<FeeOverview />
				</div>
			</div>
			<AccountOverview />
			<PortfolioChart />
			<PositionsTable />
			<div className="grid gap-8 lg:grid-cols-2 lg:gap-0 lg:divide-x lg:divide-border">
				<div className="min-w-0 lg:pr-8">
					<BalancesTable />
				</div>
				<div className="min-w-0 lg:pl-8">
					<OpenOrdersTable />
				</div>
			</div>
			<RecentTradesTable />
			<TransactionHistoryTable />
		</div>
	);
}
